module.exports = __webpack_public_path__ + "static/media/battered-axe.819d2726.svg";